module.exports = __webpack_public_path__ + "38b76acbf4c9f3fab09a59389361e6f9.pdf";